module.exports = __webpack_public_path__ + "static/media/blank.3833efb9.png";